export default __webpack_public_path__ + "static/findy-de16ca1c1436338bbcc967bde536b5b9.png";